import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import {LocationQueryRaw} from "vue-router";
import * as YachtService from "@/services/yacht.service";
import * as BlogService from "@/services/blog.service";
import * as CmsService from "@/services/cms.service";

export const useHomepageStore = defineStore('homepageStore', () => {

    const featuredYachts = ref([]);
    const loadingFeaturedY = ref(false);

    const featuredArticles = ref([]);
    const loadingFeaturedA = ref(false);

    const categories = ref<string[]>([])
    const destinations = ref<string[]>([])

    const dateFrom = ref<Date | null>(null)
    const dateTo = ref<Date | null>(null)

    const homepageData = ref(null);
    const heroImageUrl = ref("");


    async function fetchHomepageData() {

        try {

            const cachedImageUrl = localStorage.getItem("heroImageUrl");
            if (cachedImageUrl) {
                heroImageUrl.value = cachedImageUrl;
            }

            const response = await CmsService.getHomePageContents();
            homepageData.value = response.data;

            const newImageUrl = response.data.heroImage?.max || response.data.heroImage?.full;

            if (newImageUrl && newImageUrl !== cachedImageUrl) {
                await preloadImage(newImageUrl);
                heroImageUrl.value = newImageUrl;
                localStorage.setItem("heroImageUrl", newImageUrl);
            }

            // status.value = "success";
        } catch (error) {
            console.error("[HomepageStore] Failed to load homepage data:", error);
            // status.value = "error";
        }
    }

    function preloadImage(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = resolve;
            img.onerror = reject;
        });
    }


    const dateRange = computed({
        get: () => {
            return dateFrom.value && dateTo.value ? [dateFrom.value, dateTo.value] : []
        },
        set: ([start, end]) => {
            dateFrom.value = start
            dateTo.value = end
        }
    })

    const query = computed(() => {
        const q: LocationQueryRaw = {};

        if (categories.value.length > 0) {
            q['categories'] = categories.value
        }

        if (destinations.value.length > 0) {
            q['destinations'] = destinations.value
        }

        if (dateFrom.value != null) {
            q['dateFrom'] = dateFrom.value.toISOString().split('T')[0] // Format: YYYY-MM-DD
        }

        if (dateTo.value !== null) {
            q['dateTo'] = dateTo.value.toISOString().split('T')[0]
        }

        return q
    })

    function reset() {
        categories.value = []
        destinations.value = []
        dateFrom.value = null
        dateTo.value = null
    }


    async function getFeaturedYachts() {
        loadingFeaturedY.value = true;
        try {
            const response = await YachtService.getFeaturedYachts();

            if (!response) {
                console.error("Yachts not found");
                featuredYachts.value = [];
                return null;
            }
            featuredYachts.value = response;
            console.log("Yachts loaded in store:", featuredYachts.value);
        } catch (error) {
            console.error("Error fetching yachts:", error);
            featuredYachts.value = [];
        } finally {
            loadingFeaturedY.value = false;
        }
    }

    async function getFeaturedArticles() {
        loadingFeaturedA.value = true;
        try {
            const response = await BlogService.getFeaturedArticles();
            if (!response) {
                console.error("Articles not found");
                featuredArticles.value = [];
                return null;
            }
            featuredArticles.value = response;
            console.log("Articles loaded in store:", featuredArticles.value);
        } catch (error) {
            console.error("Error fetching articles:", error);
            featuredArticles.value = [];
        } finally {
            loadingFeaturedA.value = false;
        }
    }


    return {
        categories,
        destinations,
        dateFrom,
        dateTo,
        dateRange,
        query,
        reset,
        getFeaturedYachts,
        getFeaturedArticles,
        featuredYachts,
        featuredArticles,
        loadingFeaturedY,
        loadingFeaturedA,
        heroImageUrl,
        fetchHomepageData
    }
})
